import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function UserAdd({ outline, ...props }: IconProps): JSX.Element {
  return outline ? (
    <UserAdd.Outline {...props} />
  ) : (
    <UserAdd.Solid {...props} />
  );
}

UserAdd.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <g fill="currentColor">
        <path d="M9.8766 2C6.94073 2 4.56033 4.38017 4.5596 7.31666C4.54984 10.2443 6.91417 12.6255 9.84292 12.636L9.8456 12.636H9.8766C12.8138 12.636 15.1946 10.2552 15.1946 7.318C15.1946 4.38079 12.8138 2 9.8766 2ZM6.0596 7.318C6.0596 5.20911 7.76892 3.5 9.8766 3.5C11.9854 3.5 13.6946 5.20921 13.6946 7.318C13.6946 9.42679 11.9854 11.136 9.8766 11.136H9.84701C7.74679 11.1278 6.05208 9.42003 6.0596 7.32068V7.318Z" />
        <path d="M9.87651 14.4563C7.93864 14.4563 6.05515 14.6 4.63311 15.0767C3.91829 15.3163 3.26435 15.658 2.7824 16.1583C2.28266 16.6771 1.99951 17.3353 1.99951 18.1153C1.99951 18.8937 2.28022 19.5523 2.77715 20.073C3.25679 20.5756 3.90846 20.9206 4.62262 21.1634C6.04308 21.6463 7.92738 21.7953 9.87651 21.7953C11.815 21.7953 13.6984 21.6514 15.1204 21.1745C15.8351 20.9348 16.4889 20.5931 16.9708 20.0928C17.4704 19.5742 17.7535 18.916 17.7535 18.1363C17.7535 17.3581 17.4729 16.6997 16.976 16.179C16.4965 15.6765 15.845 15.3315 15.1309 15.0886C13.7105 14.6056 11.8262 14.4563 9.87651 14.4563ZM3.49951 18.1153C3.49951 17.7313 3.62674 17.4439 3.86268 17.199C4.11642 16.9356 4.52348 16.6955 5.10991 16.4989C6.29037 16.1031 7.97038 15.9563 9.87651 15.9563C11.7918 15.9563 13.471 16.1085 14.6479 16.5087C15.2324 16.7075 15.638 16.9496 15.8908 17.2146C16.1264 17.4614 16.2535 17.751 16.2535 18.1363C16.2535 18.5201 16.1264 18.8073 15.8905 19.0522C15.6368 19.3156 15.2298 19.5557 14.6434 19.7523C13.4631 20.1482 11.7831 20.2953 9.87651 20.2953C7.96164 20.2953 6.28244 20.1433 5.1054 19.7432C4.52081 19.5445 4.11523 19.3025 3.86231 19.0374C3.62668 18.7905 3.49951 18.5009 3.49951 18.1153Z" />
        <path d="M19.2039 7.91919C19.6181 7.91919 19.9539 8.25498 19.9539 8.66919V9.92407H21.2497C21.6639 9.92407 21.9997 10.2599 21.9997 10.6741C21.9997 11.0883 21.6639 11.4241 21.2497 11.4241H19.9539V12.6792C19.9539 13.0934 19.6181 13.4292 19.2039 13.4292C18.7896 13.4292 18.4539 13.0934 18.4539 12.6792V11.4241H17.1597C16.7455 11.4241 16.4097 11.0883 16.4097 10.6741C16.4097 10.2599 16.7455 9.92407 17.1597 9.92407H18.4539V8.66919C18.4539 8.25498 18.7896 7.91919 19.2039 7.91919Z" />
      </g>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

UserAdd.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          d="M21.101 10.0879H19.8979V8.91162C19.8979 8.40945 19.4952 8 18.999 8C18.5038 8 18.1 8.40945 18.1 8.91162V10.0879H16.899C16.4027 10.0879 16 10.4973 16 10.9995C16 11.5016 16.4027 11.9111 16.899 11.9111H18.1V13.0884C18.1 13.5906 18.5038 14 18.999 14C19.4952 14 19.8979 13.5906 19.8979 13.0884V11.9111H21.101C21.5962 11.9111 22 11.5016 22 10.9995C22 10.4973 21.5962 10.0879 21.101 10.0879Z"
          className="icon-secondary"
        />
        <path
          d="M9.5 15.5156C5.45422 15.5156 2 16.1625 2 18.7467C2 21.33 5.4332 22.0001 9.5 22.0001C13.5448 22.0001 17 21.3533 17 18.769C17 16.1848 13.5668 15.5156 9.5 15.5156Z"
          className="icon-primary"
        />
        <path
          opacity="0.4"
          d="M9.50023 13.0542C12.2548 13.0542 14.4629 10.8177 14.4629 8.02761C14.4629 5.23754 12.2548 3 9.50023 3C6.74566 3 4.5376 5.23754 4.5376 8.02761C4.5376 10.8177 6.74566 13.0542 9.50023 13.0542Z"
          className="icon-secondary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
